import { MessageSquare, Send } from "lucide-react";
import { useState } from "react";
import { LastFetchedAt } from "./timers/LastFetchedAt";
import { ClipLoader } from "react-spinners";

export const CommentSectionUI = ({ comments, onAddComment, loading, error, isCommentsDisabled=false }) => {
  const [newComment, setNewComment] = useState('');

  const handleSubmit = async () => {
    if (!newComment.trim()) return;
    await onAddComment(newComment);
    setNewComment('');
  };

  return (
    <div className="bg-white/50 p-6 rounded-xl mb-8 border border-blue-100">
      {error && <p className="text-red-500 font-semibold mb-4">{"*" + error}</p>}
      <div className="px-6 py-6 bg-white/10 backdrop-blur-sm rounded-xl border shadow-lg">
        <h3 className="text-lg font-bold text-gray-800 mb-3 flex items-center">
          <MessageSquare size={20} className="mr-2"/>Feedback & Comments
        </h3>

        <div className="space-y-4">
          {comments.map(c => (
            <div key={c.id} className="bg-gray-100 p-3 rounded-lg">
              <div className="flex justify-between items-center mb-1">
                <p className="font-semibold text-sm text-gray-800">{c.author_name}</p>
                <p className="text-xs text-gray-500">
                  <LastFetchedAt timestamp={c.created_at} action="" />
                </p>
              </div>
              <p className="text-sm text-gray-700">{c.content}</p>
            </div>
          ))}
        </div>

        <div className="mt-4 flex">
          {!loading ? (
            <>
              <input
                type="text"
                placeholder="Add your feedback..."
                value={newComment}
                onChange={e => setNewComment(e.target.value)}
                onKeyDown={e => e.key === "Enter" && handleSubmit()}
                className="flex-grow p-2 border rounded-l-lg text-sm"
                disabled={isCommentsDisabled}
              />
              <button
                onClick={handleSubmit}
                className={` text-white p-2 rounded-r-lg ${isCommentsDisabled ? '' : 'hover:bg-indigo-700'} ${isCommentsDisabled ? 'bg-gray-500': 'bg-indigo-600'}`}
                disabled={isCommentsDisabled}
              >
                <Send size={20}/>
              </button>
            </>
          ) : (
                <div className="flex justify-center items-center w-full py-2">
                  <ClipLoader size={20} color="#4f46e5" />
                </div>)
            }
        </div>
      </div>
    </div>
  );
};
